export const prefix = "";

export const paths = {
  login: prefix + "/",
  home: prefix + "/home",
  forgetPassword: prefix + "/esqueceu_a_senha",

  customers: prefix + "/clientes",
  users: prefix + "/usuarios",
  deposits: prefix + "/depositos",
  refund: prefix + "/refund",
  checkDocuments: prefix + "/analisarDocumentos",
  blog: prefix + "/blog",
  nft: prefix + "/nft",
  preservedAres: prefix + "/areasPreservadas",
  editProfile: prefix + "/editarPerfil",

  profile: prefix + "/perfil",
  geral: prefix + "/geral",
  general: prefix + "/general",
  detail: prefix + "/detail",
  system: prefix + "/system",
};
